/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2023, Zumper
 */

import { css } from '@emotion/react'

export const homepage = css`
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
`
